<template>
  <div class="page">
    <div class="page__title">
      {{ getModuleConfig("select_branch_page.form_title") }}
    </div>
    <div
      class="page__desc"
      v-html="getModuleConfig('select_branch_page.form_desc')"
    ></div>
    <!-- <div  class="page__content" v-if="getModuleConfig('select_branch_page.content')" v-html="getModuleConfig('select_branch_page.content')"></div> -->

    <coupon-filters
      class="s-mb-3"
      :options="filterOptions"
      v-model="filter"
    ></coupon-filters>

    <div>
      <Loading v-if="showLoading" loading-message="載入中..." />
      <div v-else-if="!showLoading && filter == 'qrcode'">
        <QRCodeScanner
          v-if="showQrCodeScanner"
          @onScan="onScan"
        />
        <input
            class="search__input mx-auto w-100 mt-3" disabled v-model="result"
        />
        <SharedButton v-if="!showQrCodeScanner" class="s-btn-bg-primary mt-3" @click="showQrCodeScanner = true">
          開啟 QR Code 掃瞄器
        </SharedButton>
      </div>
      <div v-else-if="!showLoading && filter == 'manual'">
        <input
          v-model="result"
          class="search__input m-auto w-100"
        />
      </div>
      <div v-else-if="!showLoading && filter == 'liff_scanner'">
        <input
          v-model="result"
          disabled
          class="search__input m-auto w-100"
        />
        <SharedButton class="s-btn-bg-primary mt-3" @click="openQRCodeReader()">
          開啟 QR Code 掃瞄器
        </SharedButton>
      </div>
    </div>

    <div
      v-if="
        getModuleConfig('select_branch_page.button_text') ||
        getModuleConfig('select_branch_page.cancel_button_text')
      "
      class="p-3 fixed-bottom bg-white footer"
    >
      <SharedButton class="s-btn-bg-primary mb-2"
      @click="$router.push({ name: 'LiffCouponListRedeemConfirm' })">{{
        getModuleConfig("select_branch_page.button_text")
      }}</SharedButton>
      <SharedButton variant="outline-dark" class="s-btn-outline-primary">{{
        getModuleConfig("select_branch_page.cancel_button_text")
      }}</SharedButton>
    </div>
  </div>
</template>

<script>
import liff from "@line/liff";
import Loading from "@/components/Page/Liff/Shared/Loading";
import SharedButton from "@/components/Page/Liff/Shared/Button";
import couponMixin from "@/mixins/liff/coupon";
import CouponFilters from "@/pages/Dashboard/Coupon/CouponFilters.vue";
import QRCodeScanner from "@/components/QRCodeScanner";

export default {
  mixins: [couponMixin],
  components: { Loading, SharedButton, CouponFilters, QRCodeScanner },
  data() {
    return {
      showLoading: false,
      options: [
        { text: "Avnet", value: "Avnet" },
        { text: "Arrow", value: "Arrow" },
        { text: "Burnon", value: "Burnon" },
      ],
      proxy: null,
      filter: "qrcode",
      barcode: null,
      result: null,
      showQrCodeScanner: true,
    };
  },

  computed: {
    filterOptions() {
      return [
        {
          key: "qrcode",
          text: "QR Code 掃描",
        },
        {
          key: "manual",
          text: "手動輸入",
        },
        {
          key: "liff_scanner",
          text: "LINE QRCode 掃描"
        }
      ];
    },
  },
  watch: {
    filter(val) {
      if (val === "liff_scanner") {
        this.openQRCodeReader();
      }
    },
  },
  mounted() {},

  methods: {
    onScan (decodedText) {
      console.log(decodedText);
      this.barcode = decodedText
      this.result = decodedText
      this.showQrCodeScanner = false
    },
    async openQRCodeReader() {
      liff
        .scanCodeV2()
        .then((result) => {
          this.result = result.value;
          console.log("line scan result", result);
        })
        .catch((error) => {
          this.error = error;
          console.log("error", error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.search {


  &__input {
    background: #ffffff;
    border-radius: 10px !important;
    border: 1px solid var(--liff-button-color);
    padding: 15px 12px;
    font-weight: 600;
    font-size: 16px;
    line-height: 18px;

    &::placeholder {
      letter-spacing: -0.408px;
      color: #b7b7b7;
    }

    &:focus {
      border: 1px solid var(--liff-button-color);
      outline: none;
    }
  }


}
</style>
